import { createRootRoute, Outlet } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { AnalyticsProvider } from '@/providers/AnalyticsProvider'

export const Route = createRootRoute({
  component: RootLayout,
})

const TITLE = 'Genie — A genie in your studio'
const DESCRIPTION =
  'Say what you want. Genie plans the work, runs open models for image, video and music on your own Mac, and lands every result on a canvas you keep editing. Cloud models when you want them.'
const SHORT = 'An agentic creative studio. Local first, cloud when you call.'

function RootLayout() {
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={SHORT} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Genie" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={TITLE} />
        <meta name="twitter:description" content={SHORT} />
      </Helmet>
      <AnalyticsProvider>
        <Outlet />
      </AnalyticsProvider>
    </>
  )
}
